module.exports = __webpack_public_path__ + "static/img/stateminister.ef34fd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stateminister.jpg
// module id = MTjI
// module chunks = 0